module.exports = __webpack_public_path__ + "img/bd-berserker-barb.7d9f1b84.png";